'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var GridDeleteRowButtonController = function GridDeleteRowButtonController($scope, $rootScope, $q, systemConfigButtonsUtilsService, configService) {
  var gridPanel = $scope.gridPanelScope;
  $scope.isGridEditable = gridPanel.jqxGridSettings.editable;
  $scope.isDeleteButtonShown = false;
  function isAnyFareBrandUsed(rowsToRemove, normalizations, assignments) {
    return _.some(rowsToRemove, function (rowToRemove) {
      return isUsedInNormalizations(normalizations, rowToRemove) || isUsedInAssignments(assignments, rowToRemove);
    });
  }
  function isUsedInNormalizations(normalizations, rowToRemove) {
    var fareBrandToRemove = rowToRemove.fareBrandConfiguration;
    return !_.isEmpty(normalizations[rowToRemove.carrier]) && normalizations[rowToRemove.carrier].indexOf(fareBrandToRemove) !== -1;
  }
  function isUsedInAssignments(assignments, rowToRemove) {
    var fareBrandToRemove = rowToRemove.fareBrandConfiguration;
    return !_.isEmpty(assignments[rowToRemove.carrier]) && assignments[rowToRemove.carrier].indexOf(fareBrandToRemove) !== -1;
  }
  function checkIfShouldConfirmUsedFareBrandsDeletion() {
    return isModalForDAFareBrandHepGrid() && isAnyFareBrandUsed(getRowsToBeRemoved(), configService.getDAFareBrandNormalizations(), configService.getDAFareBrandAssignments());
  }
  function isModalForDAFareBrandHepGrid() {
    var loadedData = gridPanel.jqxGridSettings.source.loadedData;
    return gridPanel.gridId === 'configuration-parameters-advanced-modal' && !_.isEmpty(loadedData) && loadedData[0].fareBrandConfiguration && loadedData[0].shortName;
  }
  function isModalForAnyComplexHepGrid() {
    return gridPanel.gridId === 'configuration-parameters-advanced-modal';
  }
  function confirm() {
    var defer = $q.defer();
    if (gridPanel.askConfirmationOnDelete && gridPanel.gridId !== 'user-fare-exclusion-rules' && gridPanel.gridId !== 'configuration-linked-fbc') {
      if (checkIfShouldConfirmUsedFareBrandsDeletion()) {
        $rootScope.$broadcast('confirmation:show', 'delete-item', null, 'DA_FareBrandDefinition');
      } else if (isModalForAnyComplexHepGrid()) {
        defer.resolve();
      } else {
        $rootScope.$broadcast('confirmation:show', 'delete-item');
      }
      var unbindConfirmEvent = $scope.$on('confirmation:delete-item:result', function (e, res) {
        if (res) {
          defer.resolve();
        } else {
          defer.reject();
        }
        unbindConfirmEvent();
      });
    } else {
      defer.resolve();
    }
    return defer.promise;
  }
  $scope.remove = function (rowsToBeRemovedFromServer) {
    if (_.isFunction($scope.customRemove)) {
      return $scope.customRemove(rowsToBeRemovedFromServer, gridPanel.jqxGridSettings.source.loadedData, $scope.selectedRowIndexes);
    } else {
      toastr.error('Remove function is not available for this grid.');
      return false;
    }
  };
  $scope.onRowSelection = function (selectedRows, selectedRowIndexes) {
    $scope.isDeleteButtonShown = !$scope.isDefaultLevel && $scope.isGridEditable && selectedRows.length > 0;
    $scope.selectedRowIndexes = selectedRowIndexes;
  };
  function removeRowsFromGrid(selectedRowIndexes, data) {
    _.remove(data, function (value, index) {
      return _.includes(selectedRowIndexes, index);
    });
  }
  function removeRowsFromServer(loadedData, selectedRowIndexes) {
    var rowsToBeRemovedFromServer = _.transform(selectedRowIndexes, function (result, index) {
      var row = loadedData[index];
      if (!row.isNewlyAdded) {
        result.push(row);
      }
      return result;
    });
    if (!_.isEmpty(rowsToBeRemovedFromServer)) {
      $scope.remove(rowsToBeRemovedFromServer);
    }
  }
  function removeRowsFromJqxGridLoadedData(data) {
    if (!$scope.disableRemovingFromServer) {
      removeRowsFromServer(data, $scope.selectedRowIndexes);
    }
    removeRowsFromGrid($scope.selectedRowIndexes, data);
    systemConfigButtonsUtilsService.reloadGrid(gridPanel);
  }
  function getRowsToBeRemoved() {
    var rowsToBeRemoved = [];
    _.forEach(gridPanel.jqxGridSettings.source.loadedData, function (value, index) {
      if (_.includes($scope.selectedRowIndexes, index)) {
        rowsToBeRemoved.push(value);
      }
    });
    return rowsToBeRemoved;
  }
  function removeRowsFromGridPanelLocalData() {
    if (!$scope.disableRemovingFromServer) {
      removeRowsFromServer(gridPanel.jqxGridSettings.source.loadedData, $scope.selectedRowIndexes);
    }
    _.pullAll(gridPanel.localData, getRowsToBeRemoved());
    systemConfigButtonsUtilsService.reloadGrid(gridPanel);
  }
  $scope.removeRows = function () {
    confirm().then(function () {
      if (systemConfigButtonsUtilsService.hasLocalData(gridPanel)) {
        removeRowsFromGridPanelLocalData();
      } else {
        removeRowsFromJqxGridLoadedData(gridPanel.jqxGridSettings.source.loadedData);
      }
    });
  };
};
GridDeleteRowButtonController.$inject = ['$scope', '$rootScope', '$q', 'SystemConfigButtonsUtilsService', 'ConfigurationService'];
module.exports = GridDeleteRowButtonController;